import React from 'react';
import reactLogo from './assets/logo.svg';
import codingLogo from './assets/coding-logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="logos">
          <img src={reactLogo} className="App-logo" alt="logo" />
          <img src={codingLogo} className="coding-logo" alt="coding" />
        </div>
        </header>   
      <div className="App-body">
        <div>
          如何将本页面通过「CODING 持续集成」自动部署到 <a className="App-link" href="https://cloud.tencent.com/product/cos" target="_blank" rel="noopener noreferrer">腾讯云 对象存储 COS</a>
          <br></br>
          请查看 
          <a className="App-link" href="https://help.coding.net/docs/devops/ci/practice/static-website-paas.html" target="_blank" rel="noopener noreferrer"> CODING 帮助文档</a>.
        </div>
        <h3>了解更多 CODING 产品</h3>
        <ul>
          <li><a className="App-link" href="https://coding.net/" target="_blank" rel="noopener noreferrer">CODING 主页</a></li>
          <li><a className="App-link" href="https://coding.net/products/ci" target="_blank" rel="noopener noreferrer">CODING 持续集成</a></li>
        </ul>
        <h3>如何继续开发您的应用？</h3>
        <ul>
          <li><a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
          >
          Learn React
        </a></li>
        </ul>
      </div>
    </div>
  );
}

export default App;
